<accordion>
  <accordion-panel>
    <div panel-header>GIS Query Context Data Sources</div>
    <div class="cell small-12 bold small-font-size">
      Leave blank to use the alternate fields below.
    </div>
    <div class="grid-x">
      @for (opt of data.arguments.readContextOptions; track opt) {
        <div class="cell small-5 small-font-size">
          {{opt.displayName}}
        </div>
        <div class="cell small-7">
          <input [id]="opt.index" type="text" [(ngModel)]="opt.location" />
        </div>
      }
    </div>
  </accordion-panel>
  <accordion-panel>
    <div panel-header>Alternate GIS Query Context Data Sources</div>
    <div class="cell small-12 bold small-font-size">
      These options for location will be used if the options above are left blank.
    </div>
    <div class="grid-x">
      @for (opt of data.arguments.alternateReadContextOptions; track opt) {
        <div class="cell small-5 small-font-size">
          {{opt.displayName}}
        </div>
        <div class="cell small-7">
          <input [id]="opt.index" type="text" [(ngModel)]="opt.location" />
        </div>
      }
    </div>
  </accordion-panel>
  <accordion-panel>
    <div panel-header>Context Targets to Save GIS Location Results</div>
    <div class="grid-x">
      <div class="cell small-12 bold small-font-size">
        Leave a field blank if you do not want this controller to update the related location value
      </div>
      @for (opt of locationWriteOptions; track opt) {
        <div class="cell small-5 small-font-size">
          {{opt.displayName}}
        </div>
        <div class="cell small-7">
          <input [id]="opt.index" type="text" [(ngModel)]="opt.location" />
        </div>
      }
    </div>
  </accordion-panel>
  <accordion-panel>
    <div panel-header>Context targets to Save GIS Conditions (Urban Area, Watershed, etc)</div>
    <div class="grid-x">
      <div class="cell small-12 bold small-font-size">
        Leave a field blank if you do not want this controller to update the related condition value
      </div>
      @for (opt of conditionWriteOptions; track opt) {
        <div class="cell small-5 small-font-size">
          {{opt.displayName}}
        </div>
        <div class="cell small-7">
          <input [id]="opt.index" type="text" [(ngModel)]="opt.location" />
        </div>
      }
    </div>
  </accordion-panel>
</accordion>